import Routes from './routes';
import { Flip, IconProps, ToastContainer } from 'react-toastify';
import IconSuccess from '@/assets/common/ic_success_circle.svg?react';
import IconError from '@/assets/common/ic_error_circle.svg?react';
import 'react-toastify/dist/ReactToastify.css';
import './Toastify.css';
import './App.css';

function CustomToastContainer() {
  const handleIcon = (props: IconProps) => {
    const { type } = props;
    switch (type) {
      case 'success':
        return <IconSuccess className="w-4 h-4" />;
      case 'error':
        return <IconError className="w-4 h-4" />;
      default:
        return null;
    }
  };

  return <ToastContainer hideProgressBar={true} autoClose={1500} position="top-center" transition={Flip} closeButton={false} icon={handleIcon} />;
}

function App() {
  return (
    <div className="w-full h-full">
      <Routes />
      <CustomToastContainer />
    </div>
  );
}

export default App;
